import { OrgType } from '~/hooks/state'

export const replaceQuery = (
  query: string,
  clusterId: string,
  orgType: OrgType,
  deployType?: string,
  instanceName = '.*',
  nodeInstance = '.*',
  keyspaceId?: number
) => {
  let q: string
  if (orgType === 'op') {
    q = query.replaceAll('{label_cluster_id}', `tidb_cluster="${clusterId}"`)

    // for operator, `label_component` is `component`
    if (deployType === 'tidb-operator') {
      q = q.replaceAll('{label_component}', 'component')
    } else {
      // for tiup, `label_component` is `job`
      q = q.replaceAll('{label_component}', 'job')
    }
  } else {
    q = query
      .replaceAll('{label_cluster_id}', `cluster_id=~".*${clusterId}"`)
      .replaceAll('{label_tidb_cluster_id}', `tidb_cluster_id="${clusterId}"`)
      .replaceAll('{label_instance_name}', `instance=~"${instanceName}"`)
      .replaceAll('{label_component}', 'component')
      .replaceAll('{label_node_instance}', `instance="${nodeInstance}"`)
      .replaceAll(
        '{label_serverless_keyspace_id_to_name}',
        `name="${keyspaceId || ''}"`
      )
      .replaceAll(
        '{label_serverless_keyspace_id}',
        `keyspace_id="${keyspaceId || ''}"`
      )
  }

  return q.replaceAll('+', encodeURIComponent('+'))
}
